export const DISCOUNT_TYPES = {
  PRODUCT: 'PRODUCT',
  RESTAURANT: 'RESTAURANT',
}
